import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowRight, CircleAlert, CircleCheck, PauseCircle, ShieldAlert } from 'lucide-react';
import { formatCurrency } from '../lib/market';
export function ActionSummary({ plan }) {
    if (!plan)
        return _jsxs("section", { className: "action-summary action-loading", children: [_jsx("span", { className: "pulse-dot" }), "Loading data and assessing risk boundaries\u2026"] });
    const content = actionContent(plan);
    return _jsxs("section", { className: `action-summary ${content.tone}`, children: [_jsx("div", { className: "action-symbol", children: content.icon }), _jsxs("div", { className: "min-w-0 flex-1", children: [_jsx("p", { className: "action-eyebrow", children: "Today's Recommendation" }), _jsx("h2", { children: content.title }), _jsx("p", { className: "action-copy", children: content.description }), _jsxs("div", { className: "mt-4 flex flex-wrap gap-2 text-xs", children: [_jsxs("span", { className: "fact-pill", children: ["Data as of ", new Date(plan.dataAsOf).toLocaleString('en-US')] }), _jsxs("span", { className: "fact-pill", children: ["Defensive Layer ", formatCurrency(plan.defensiveAmount)] }), _jsxs("span", { className: "fact-pill", children: ["Worst 5% Average ", formatCurrency(plan.risk.worstFivePercentAverage * (plan.defensiveAmount + plan.riskAmount))] })] })] }), _jsxs("div", { className: "action-side", children: [_jsx("span", { children: "View Rationale" }), _jsx(ArrowRight, { size: 17 })] })] });
}
function actionContent(plan) {
    if (plan.state === 'NORMAL')
        return {
            tone: 'action-normal',
            icon: _jsx(CircleCheck, { size: 28 }),
            title: 'Proceed with Phased Allocation',
            description: 'Risk metrics are nominal. If executing, proceed only with the first tranche and evaluate subsequent tranches after the next market close.'
        };
    if (plan.state === 'CAUTION')
        return {
            tone: 'action-caution',
            icon: _jsx(PauseCircle, { size: 28 }),
            title: 'Pause Additional Risk Allocation',
            description: 'Trend or volatility signals indicate caution. Maintain current defensive buffers and await confirmation from the next post-close data.'
        };
    if (plan.state === 'RISK_OFF')
        return {
            tone: 'action-risk',
            icon: _jsx(ShieldAlert, { size: 28 }),
            title: 'Prioritize Defensive Buffer Recovery',
            description: 'Tail risk or trend metrics exceed defined thresholds. Displaying de-risking actions only; do not add risk assets.'
        };
    return {
        tone: 'action-stale',
        icon: _jsx(CircleAlert, { size: 28 }),
        title: 'Data Refresh Required',
        description: 'The current market snapshot does not meet criteria for generating a new plan. Refresh the data or await the next automated update.'
    };
}
